const navbar = "app-navbar";

export { navbar };
